import React from "react";

const ArrowsMoveIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      id="arrows_move_icon"
      data-name="arrows move"
      {...props}
      width={props.width || "24"}
      height={props.height || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 11H13V6H16L12 2L8 6H11V11H6V8L2 12L6 16V13H11V18H8L12 22L16 18H13V13H18V16L22 12L18 8V11Z"
        fill={props.fill || "#3A8AB9"}
      />
    </svg>
  );
};

export default ArrowsMoveIcon;
